// Services
import { TargetRatesService } from 'TargetRatesApp/services/target-rates.service';
import * as i0 from "@angular/core";
import * as i1 from "TargetRatesApp/services/target-rates.service";
import * as i2 from "@angular/common";
const _c0 = a0 => ({ indicators: a0 });
const _forTrack0 = ($index, $item) => $item.name;
function KeyRatesComponent_For_7_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 6)(1, "a", 11);
    i0.ɵɵlistener("click", function KeyRatesComponent_For_7_Template_a_click_1_listener() { const subtab_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateIndex(subtab_r2)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const subtab_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r2.activeSubtab === subtab_r2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", subtab_r2, " ");
} }
function KeyRatesComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function KeyRatesComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function KeyRatesComponent_ng_template_15_For_18_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const indicator_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(indicator_r4.change_month_ago[0] === "-" ? "text-red" : "text-green");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", indicator_r4.change_month_ago, "");
} }
function KeyRatesComponent_ng_template_15_For_18_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " -- ");
} }
function KeyRatesComponent_ng_template_15_For_18_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const indicator_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(indicator_r4.change_year_ago[0] === "-" ? "text-red" : "text-green");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", indicator_r4.change_year_ago, "");
} }
function KeyRatesComponent_ng_template_15_For_18_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " -- ");
} }
function KeyRatesComponent_ng_template_15_For_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "a", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td", 17);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 17);
    i0.ɵɵtemplate(7, KeyRatesComponent_ng_template_15_For_18_Conditional_7_Template, 2, 3, "span", 18)(8, KeyRatesComponent_ng_template_15_For_18_Conditional_8_Template, 1, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 17);
    i0.ɵɵtemplate(10, KeyRatesComponent_ng_template_15_For_18_Conditional_10_Template, 2, 3, "span", 18)(11, KeyRatesComponent_ng_template_15_For_18_Conditional_11_Template, 1, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td", 17);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td", 17);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "date");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const indicator_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", indicator_r4.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(indicator_r4.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(indicator_r4.value);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(indicator_r4.change_month_ago !== null ? 7 : 8);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(indicator_r4.change_year_ago !== null ? 10 : 11);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(indicator_r4.long_term_avg !== null ? indicator_r4.long_term_avg : "--");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(16, 7, indicator_r4.last_update, "MM/d/yy"));
} }
function KeyRatesComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 12)(1, "thead")(2, "tr")(3, "td", 13);
    i0.ɵɵtext(4, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 14);
    i0.ɵɵtext(6, "Current Value (%)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 14);
    i0.ɵɵtext(8, "1M Change");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 14);
    i0.ɵɵtext(10, "1Y Change");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 14);
    i0.ɵɵtext(12, "Historical Avg.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td", 14);
    i0.ɵɵtext(14, "Last Update");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "td", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "tbody");
    i0.ɵɵrepeaterCreate(17, KeyRatesComponent_ng_template_15_For_18_Template, 17, 10, "tr", null, _forTrack0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const indicators_r5 = ctx.indicators;
    i0.ɵɵadvance(17);
    i0.ɵɵrepeater(indicators_r5);
} }
export class KeyRatesComponent {
    constructor(targetRatesService) {
        this.targetRatesService = targetRatesService;
        this.indicesTabs = ['Core Treasury Yields', 'Credit Rates Yields'];
        this.activeSubtab = this.indicesTabs[0];
        this.DailyTreasuryYieldCurveRatesIndicators = [];
        this.BankOfAmericaMerrillLynchIndicators = [];
    }
    ngOnInit() {
        this.targetRatesService.getKeyRatesIndicators().subscribe((response) => {
            this.DailyTreasuryYieldCurveRatesIndicators = response.daily_treasury_yield_curve_rates;
            this.BankOfAmericaMerrillLynchIndicators = response.bank_of_america_merrill_lynch;
        });
    }
    updateIndex(subtab) {
        this.activeSubtab = subtab;
    }
}
KeyRatesComponent.ɵfac = function KeyRatesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || KeyRatesComponent)(i0.ɵɵdirectiveInject(i1.TargetRatesService)); };
KeyRatesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: KeyRatesComponent, selectors: [["ycn-key-rates"]], standalone: false, decls: 17, vars: 12, consts: [["tableLayout", ""], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-tabs", "tabs"], [1, "nav", "nav-tabs"], [1, "nav-item"], [1, "panel-tabs", "tab-content"], [1, "tab-pane"], [1, "panel-content"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click"], [1, "table"], [1, "text-thin"], [1, "text-thin", "text-right"], [1, "visible-lg-table-cell"], [3, "href"], [1, "text-right"], [1, "text-bold", 3, "class"], [1, "text-bold"]], template: function KeyRatesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "h3", 3);
        i0.ɵɵtext(3, "Key Rates");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 4)(5, "ul", 5);
        i0.ɵɵrepeaterCreate(6, KeyRatesComponent_For_7_Template, 3, 3, "li", 6, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 7)(9, "div", 8)(10, "div", 9);
        i0.ɵɵtemplate(11, KeyRatesComponent_ng_container_11_Template, 1, 0, "ng-container", 10);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 8)(13, "div", 9);
        i0.ɵɵtemplate(14, KeyRatesComponent_ng_container_14_Template, 1, 0, "ng-container", 10);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(15, KeyRatesComponent_ng_template_15_Template, 19, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const tableLayout_r6 = i0.ɵɵreference(16);
        i0.ɵɵadvance(6);
        i0.ɵɵrepeater(ctx.indicesTabs);
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("active", ctx.activeSubtab === ctx.indicesTabs[0]);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", tableLayout_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c0, ctx.DailyTreasuryYieldCurveRatesIndicators));
        i0.ɵɵadvance();
        i0.ɵɵclassProp("active", ctx.activeSubtab === ctx.indicesTabs[1]);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", tableLayout_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c0, ctx.BankOfAmericaMerrillLynchIndicators));
    } }, dependencies: [i2.NgTemplateOutlet, i2.DatePipe], encapsulation: 2 });
